function isReload() {
    if (window.performance !== undefined) {
        // first check new function
        if (typeof performance.getEntriesByType === "function") {
            var results = performance.getEntriesByType("navigation");
            if (Array.isArray(results) && results.length > 0 && typeof results[0].type === "string") {
                return results[0].type === "reload";
            }
        }
        // if not found check deprecated function
        if (performance.navigation !== undefined && typeof performance.navigation.type === "number") {
            return performance.navigation.type === 1;
        }
    }
    return false;
}
var isReloaded = isReload();

/**
 * @description This util object act as an cache for other util classes like user, license, version ,...
 * it prevents the the browser needs to call every pageload. The data stays the same for the session. 
 * Data is cleared if the user html session expired, or if the users logout or if a page refresh is detected
 * @namespace TemporyBrowserObjectCache
 * @version 1.0.0
 */
var TemporyBrowserObjectCache = {
    /**
     * @description Save data to the caches
     * @function
     * @name TemporyBrowserObjectCache#save
     * @param {String} pIdentifier An uniq identiefier, to identiefier the data 
     * @param {Object} pObject Data you which to cache
     * @returns undefined
     */
    save: function(pIdentifier, pObject){
        try {
            // session can not exists or storage can be full
            // so ignore errors
            sessionStorage.setItem(pIdentifier, JSON.stringify({"object": pObject, "creation": +(new Date())}));
        } catch(e) {}
    },

    /**
     * @description Retrieve the cached data. null will be returned if no data is present or 
     * if the data is too old or if security prevents access
     * @function
     * @name TemporyBrowserObjectCache#get 
     * @param {String} pIdentifier The identifier of the cached data
     * @returns {Object} The cached data or null
     */
    get: function(pIdentifier) {
        try {
            // sessionStorage can not exists or 
            // returnValue can not be JSON parsed correctly
            // in all cases ignore and go to retrieve by api call
            var stringified = sessionStorage.getItem(pIdentifier);
            if (typeof stringified === "string" && stringified.length > 0) {
                var memoryObject = JSON.parse(stringified);
                if (memoryObject.object !== undefined && memoryObject.creation !== undefined) {
                    var now = new Date();
                    if (now.setHours(now.getHours() - 12) < memoryObject.creation) { // if created more recent then history
                        return memoryObject.object;
                    }
                }
                // continue in case of wrong
                sessionStorage.removeItem(pIdentifier);
            }
        } catch(e) {
            if (window.origin === "null" && e && e.name === "SecurityError") {
                // ignore issue
            } else {
                console.error(e);
            }
        }
        return null;
    },

    /**
     * @description Remove and delete the cached data
     * @function
     * @name TemporyBrowserObjectCache#remove 
     * @param {String} pIdentifier The identifier if the cached data
     * @returns undefined
     */
    remove: function(pIdentifier) {
        if (window.sessionStorage !== undefined) {
            window.sessionStorage.removeItem(pIdentifier);
        }
    },

    /**
     * @description Check if the user click on the refresh button or not, it return also true if the refresh is caused by javascript location.reload()
     * @function
     * @name TemporyBrowserObjectCache#isPageReload
     * @returns {Boolean} true if the page has been reloaded, if the user clicked on the refresh button
     */
    isPageReload: function(){
        return isReloaded == true;
    }
};

module.exports = TemporyBrowserObjectCache;